<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Customer"></app-page-title>
        <form [formGroup]="customerForm" (ngSubmit)="addCustomer()" (keydown.enter)="useEnterKey ? $event.preventDefault() : addCustomer()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="">
                                        <label for="code" class="form-label">Code <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="code"
                                            formControlName="txtCode" maxlength="5" 
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('txtCode').touched) && customerForm.get('txtCode').errors}">
                                        <div *ngIf="(isFormSubmitted || customerForm.get('txtCode').touched) && customerForm.get('txtCode').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customerForm.get('txtCode').errors.required">Code is
                                                required</span>
                                            <span *ngIf="customerForm.get('txtCode').errors.maxlength">Code Max of 5
                                                    characters.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="">
                                        <label for="name" class="form-label">Name <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                            formControlName="txtName" maxlength="50" 
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('txtName').touched) && customerForm.get('txtName').errors}">
                                        <div *ngIf="(isFormSubmitted || customerForm.get('txtName').touched) && customerForm.get('txtName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customerForm.get('txtName').errors.required">Name is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="">
                                        <label for="contactperson" class="form-label">Contact Person </label>
                                        <input type="text" class="form-control form-control-sm" id="contactperson" 
                                            formControlName="txtContactPerson" maxlength="50">
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="">
                                        <label for="emailid" class="form-label">Email ID <span
                                                class="mandatory">*</span></label>
                                        <input type="email" class="form-control form-control-sm" id="emailid"
                                            placeholder="Ex. abc@domain.com" formControlName="txtEmailId" maxlength="50" 
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('txtEmailId').touched) && customerForm.get('txtEmailId').errors}">
                                        <div *ngIf="(isFormSubmitted || customerForm.get('txtEmailId').touched) && customerForm.get('txtEmailId').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customerForm.get('txtEmailId').errors.required"> Email is
                                                required</span>
                                            <span *ngIf="customerForm.get('txtEmailId').errors.pattern">Invalid email
                                                format</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label class="form-label">Companies <span class="mandatory">*</span></label>
                                        <ng-select [items]="companyList" [multiple]="true" [appendTo]="'body'" [openOnEnter]="false" 
                                            bindLabel="name"  formControlName="ddlCompanies"
                                            placeholder="Select" (change)="onCompaniesChange()"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('ddlCompanies')?.touched) && customerForm.get('ddlCompanies').errors}">

                                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                                    <span class="ng-value-label">{{item.name}}</span>
                                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                                </div>
                                                <div class="ng-value" *ngIf="items.length > 1">
                                                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                                                </div>
                                              </ng-template>

                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('ddlCompanies')?.touched) && customerForm.get('ddlCompanies').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customerForm.get('ddlCompanies').errors.required">At least one
                                                company has to be selected.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="industryType" class="form-label">Industry Type</label>
                                        <ng-select id="industryType" placeholder="Select" 
                                            formControlName="ddlIndustryType" [items]="industryTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            bindLabel="name" [bindValue]="'id'">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="px-3">
                                        <label for="status" class="form-label">Status</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input" 
                                                formControlName="status">
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            ADDRESS
                        </div>
                        <div class="card-body">
                            <app-location formGroupName="locationdetails"
                                [selectedSCId]="selectedSCId" [isDefaultUserLocationSelected]="true"
                                [formSubmitted]="isFormSubmitted" (getLocation)="getLocation($event)">
                            </app-location>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            INFO
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="customerType" class="form-label">Customer Type</label>
                                        <ng-select id="customerType" placeholder="Select"
                                            formControlName="ddlCustomerType" [items]="customerTypeList" 
                                            [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('ddlCustomerType').touched) && customerForm.get('ddlCustomerType').errors}">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="currency" class="form-label">Currency</label>
                                        <ng-select [items]="currencyList" bindLabel="currencycode" [bindValue]="'currencycode'" 
                                            [appendTo]="'body'" [openOnEnter]="false" placeholder="Select" formControlName="ddlCurrency">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="printAWBWithCustomerLogo" class="form-label">Print AWB with Logo</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input" 
                                                formControlName="chkPrintAWBWithCustomerLogo">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="invoiceformat" class="form-label">Invoice Template</label>
                                        <ng-select id="invoicetemplate" placeholder="Select" [items]="invoiceTemplateList"
                                            bindLabel="templatename" [bindValue]="'id'" [appendTo]="'body'"
                                            formControlName="ddlinvoiceTemplate">
                                        </ng-select>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-2">
                                        <label for="customerlogo" class="form-label">Customer Logo ( <small
                                                for="companylogo"><i class="mdi mdi-information">Note: .png, .jpeg,
                                                    .jpg,.svg are only allowed.</i></small> )</label>
                                        <div class="input-group">
                                            <input id="customerlogo" type="file" class="form-control form-control-sm" 
                                                accept=".png, .jpeg,.jpg,.svg"
                                                (change)="onChangeFileSelect($event, 'CustomerLogo')">
                                            <button type="button" class="btn btn-primary btn-sm" 
                                                (click)="uploadFile('CustomerLogo')">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>
                                        </div>
                                        <div *ngIf="showLogoProgressBar" class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="logoProgress" [attr.aria-valuenow]="logoProgress" aria-valuemin="0"
                                                aria-valuemax="100">
                                                {{logoProgress}}%
                                            </div>
                                        </div>
                                        <ng-container *ngIf="customerLogoFileURL">
                                            <a target="_blank" [href]="customerLogoFileURL">{{customerLogoFileName}}</a>
                                        </ng-container>
                                    </div>
                                </div>


                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-2">
                                        <label for="signatorylogo" class="form-label">Signatory Logo ( <small
                                                for="signatorylogo"><i class="mdi mdi-information">Note: .png, .jpeg,
                                                    .jpg, .svg are only allowed.</i></small> )</label>
                                        <div class="input-group">
                                            <input id="signatorylogo" type="file" class="form-control form-control-sm"
                                                accept=".png, .jpeg,.jpg,.svg" 
                                                (change)="onChangeFileSelect($event, 'Signature')">
                                            <button type="button" class="btn btn-primary btn-sm" 
                                                (click)="uploadFile('Signature')">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>
                                        </div>
                                        <div *ngIf="showsignatrueProgressBar" class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="signatrueProgress" [attr.aria-valuenow]="signatrueProgress" aria-valuemin="0"
                                                aria-valuemax="100">
                                                {{signatrueProgress}}%
                                            </div>
                                        </div>
                                        <ng-container *ngIf="signatureFileURL">
                                            <a target="_blank" [href]="signatureFileURL">{{signatureFileName}}</a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            KYC
                        </div>
                        <div class="card-body" formGroupName="kycdetails">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="documenttype" class="form-label">Document Type</label>
                                        <ng-select id="shipperdoc" placeholder="Select" [items]="documentOptions" 
                                            bindLabel="name" [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="documentTypeValidation()"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            formControlName="ddlDocumentType" 
                                            [ngClass]="{'is-invalid': (isKYCInfoSubmitted || customerForm.get('kycdetails.ddlDocumentType')?.touched) && customerForm.get('kycdetails.ddlDocumentType').errors}">
                                        </ng-select>
                                            <div *ngIf="(isKYCInfoSubmitted || customerForm.get('kycdetails.ddlDocumentType')?.touched) && customerForm.get('kycdetails.ddlDocumentType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customerForm.get('kycdetails.ddlDocumentType')?.errors.required">Document Type is required</span>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="documentno" class="form-label">Document No.</label>
                                        <input type="text" class="form-control form-control-sm" id="documentno" 
                                            formControlName="txtDocumentNo" (change)="trimDocumentNo($event)" [maxlength]="limitChars"
                                            [ngClass]="{'is-invalid': ( isKYCInfoSubmitted || customerForm.get('kycdetails.txtDocumentNo')?.touched) && customerForm.get('kycdetails.txtDocumentNo').errors}"/>
                                            <div *ngIf="(isKYCInfoSubmitted || customerForm.get('kycdetails.txtDocumentNo')?.touched) && customerForm.get('kycdetails.txtDocumentNo').errors"
                                                    class="invalid-feedback">
                                                <span *ngIf="customerForm.get('kycdetails.txtDocumentNo')?.errors.required">Document No. is required</span>
                                                <span *ngIf="customerForm.get('kycdetails.txtDocumentNo').errors.pattern">{{docValidationMsg}}</span>
                                            </div>
                                        
                                    </div>
                                </div>
                                <div class="col-md-4 mt-3">
                                    <div class="mb-2 mt-1"> 
                                        <button type="button" class="btn btn-primary btn-sm" (click)="addkycInfo()">
                                            <i class="mdi mdi-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-9">
                                    <div class="mb-3">
                                        <div class="input-group">
                                            <label for="documentUpload" class="form-label">Document Upload</label>
                                        </div>
                                        <small for="documentupload"><i class="mdi mdi-information">Note: .png,
                                                .jpeg,.jpg,.pdf are only allowed</i></small>
                                        <div class="input-group mb-2">
                                            <input id="documentUpload" type="file" class="form-control form-control-sm"
                                                formControlName="txtDocument" accept=".png, .jpeg, .jpg, .pdf" 
                                                (change)="onChangeFileSelect($event, 'Kyc')" />
                                            <button type="button" class="btn btn-primary btn-sm" 
                                                (click)="isKYCInfoSubmitted; uploadKyc()">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>

                                        </div>

                                    </div>
                                    <div *ngIf="showkycProgressbar" class="progress mt-2">
                                        <div class="progress-bar progress-bar-striped" role="progressbar"
                                            [style.width.%]="kycProgress" [attr.aria-valuenow]="kycProgress" aria-valuemin="0"
                                            aria-valuemax="100">
                                            {{kycProgress}}%
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">

                                <div class="table-responsive">
                                    <table class="table table-sm m-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th>Type</th>
                                                <th>Document No.</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style="max-height: 60px;">
                                            <tr *ngFor="let k of kycList; let i=index">
                                                <td>{{k.type}}</td>
                                                <td>{{k.no}}</td>
                                                <td>
                                                    <a *ngIf="k.fileid" target="_blank" [href]="k.filepath"><i
                                                            class="bx bx-show font-size-16 align-middle me-2"></i></a>
                                                    <i class="bx bx-trash font-size-16 align-middle me-2"
                                                        (click)="deleteKycItem(k.fileid, i)"></i>
                                                </td>
                                            </tr>
                                            <tr *ngIf="kycList.length === 0">
                                                <td colspan="3" class="text-center">
                                                    No records
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            BUSINESS DETAILS
                        </div>
                        <div class="card-body" formGroupName="businessDetails">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="billingType" class="form-label">Billing Type<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="billingType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [items]="billingTypeList" formControlName="ddlBillingType" 
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlBillingType')?.touched) && customerForm.get('businessDetails').get('ddlBillingType').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlBillingType')?.touched) && customerForm.get('businessDetails').get('ddlBillingType').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlBillingType').errors.required">Billing
                                                Type is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="PaymentType" class="form-label">Payment Type<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="PaymentType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [items]="paymentTypeList" formControlName="ddlPaymentType" 
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlPaymentType')?.touched) && customerForm.get('businessDetails').get('ddlPaymentType').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlPaymentType')?.touched) && customerForm.get('businessDetails').get('ddlPaymentType').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlPaymentType').errors.required">Payment
                                                Type is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="businessType" class="form-label">Business Type</label>
                                        <ng-select id="businessType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                            [items]="businessTypeList" formControlName="ddlBusinessType"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlBusinessType')?.touched) && customerForm.get('businessDetails').get('ddlBusinessType').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlBusinessType')?.touched) && customerForm.get('businessDetails').get('ddlBusinessType').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlBusinessType').errors.required">Business
                                                Type is required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="fuelapplicable" class="form-label">Fuel Applicable</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input" 
                                                formControlName="fuelApplicable">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="taxapplicable" class="form-label">Tax Applicable</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input" 
                                                formControlName="taxApplicable">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="country" class="form-label">Billing Country <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="country" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                            (change)="onCountryChange('ddlCountry')" [items]="billingCountryList"
                                            bindLabel="name" [bindValue]="'isocode'" formControlName="ddlCountry"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlCountry')?.touched) && customerForm.get('businessDetails').get('ddlCountry').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlCountry')?.touched) && customerForm.get('businessDetails').get('ddlCountry').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlCountry').errors.required">Country
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="state" class="form-label">Billing State <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                            (change)="onStateChange('ddlState')" [items]="billingStateList"
                                            bindLabel="name" [bindValue]="'isocode'" formControlName="ddlState"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlState')?.touched) && customerForm.get('businessDetails').get('ddlState').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlState')?.touched) && customerForm.get('businessDetails').get('ddlState').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlState').errors.required">State
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="salesexecutive" class="form-label">Sales Executive</label>
                                        <ng-select id="salesexecutive" placeholder="Select" 
                                            formControlName="ddlSalesExecutive" [appendTo]="'body'" [openOnEnter]="false"
                                            [items]="salesExecutiveList" bindLabel="username" [bindValue]="'id'">
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="pickupCountry" class="form-label">Origin Pickup Country <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="pickupCountry" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onCountryChange('ddlPickupCountry')" [items]="pickupCountryList"
                                            bindLabel="name" [bindValue]="'isocode'" formControlName="ddlPickupCountry"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupCountry')?.touched) && customerForm.get('businessDetails').get('ddlPickupCountry').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupCountry')?.touched) && customerForm.get('businessDetails').get('ddlPickupCountry').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlPickupCountry').errors.required">Country
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="state" class="form-label">Origin Pickup State <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onStateChange('ddlPickupState')" [items]="pickupStateList"
                                            bindLabel="name" [bindValue]="'isocode'" formControlName="ddlPickupState"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupState')?.touched) && customerForm.get('businessDetails').get('ddlPickupState').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupState')?.touched) && customerForm.get('businessDetails').get('ddlPickupState').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlPickupState').errors.required">State
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="city" class="form-label">Origin Pickup City <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="city" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="cityList"
                                            bindLabel="name" [bindValue]="'isocode'" formControlName="ddlPickupCity"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupCity')?.touched) && customerForm.get('businessDetails').get('ddlPickupCity').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customerForm.get('businessDetails').get('ddlPickupCity')?.touched) && customerForm.get('businessDetails').get('ddlPickupCity').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('businessDetails').get('ddlPickupCity').errors.required">City
                                                is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom">
                            Billing Details
                        </div>
                        <div class="card-body ">
                            <ag-grid-angular #agGrid style="height: 174px;" id="myGrid"
                                class="ag-theme-balham" [rowData]="serviceCenterRowData" [columnDefs]="serviceCenterColumnDefs"
                                [animateRows]="true" [context]="context"
                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            Rate bands
                        </div>
                        <div class="card-body" formGroupName="ratePeriodGroup">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mb-2">
                                      <label for="rateband" class="form-label">Rate Band</label>
                                      <ng-select [items]="rateBandList" bindLabel="rateband" [bindValue]="'id'" 
                                        [appendTo]="'body'" [openOnEnter]="false" placeholder="Select" formControlName="ddlRateBand"
                                        [ngClass]="{'is-invalid': (isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('ddlRateBand')?.touched) && customerForm.get('ratePeriodGroup').get('ddlRateBand').errors}">
                                      </ng-select>
                                      <div *ngIf="(isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('ddlRateBand')?.touched) &&
                                                  customerForm.get('ratePeriodGroup').get('ddlRateBand').errors" class="invalid-feedback">
                                        <span *ngIf="customerForm.get('ratePeriodGroup').get('ddlRateBand').errors.required">Rate Band is required</span>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-3">
                                    <div class="mb-2">
                                      <label for="dateTime" class="form-label">From date</label>
                                      <input type="date" class="form-control form-control-sm" formControlName="txtFromDate"
                                      [max]="customerForm.get('ratePeriodGroup').get('txtToDate').value" 
                                        [ngClass]="{'is-invalid': (isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('txtFromDate')?.touched) && customerForm.get('ratePeriodGroup').get('txtFromDate').errors}" />
                                      <div *ngIf="(isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('txtFromDate')?.touched) &&
                                                  customerForm.get('ratePeriodGroup').get('txtFromDate').errors" class="invalid-feedback">
                                        <span *ngIf="customerForm.get('ratePeriodGroup').get('txtFromDate').errors.required">From date is required</span>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-3">
                                    <div class="mb-2">
                                      <label for="dateTime" class="form-label">To date</label>
                                      <input type="date" class="form-control form-control-sm" formControlName="txtToDate"
                                        [min]="customerForm.get('ratePeriodGroup').get('txtFromDate').value" 
                                        [ngClass]="{'is-invalid': (isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('txtToDate')?.touched) && customerForm.get('ratePeriodGroup').get('txtToDate').errors}" />
                                      <div *ngIf="(isRateBandSubmitted || customerForm.get('ratePeriodGroup').get('txtToDate')?.touched) &&
                                                  customerForm.get('ratePeriodGroup').get('txtToDate').errors" class="invalid-feedback">
                                        <span *ngIf="customerForm.get('ratePeriodGroup').get('txtToDate').errors.required">To date is required</span>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-3 mt-3">
                                    <div class="mb-2 mt-1">
                                        <button type="button" class="btn btn-primary btn-sm" (click)="addRatePeriod()" >
                                            <i class="mdi mdi-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="table-responsive">
                                    <table class="table table-sm m-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th>Rate Band</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style="max-height: 60px;">
                                            <tr *ngFor="let rp of rateBandPeriodList; let i=index">
                                                <td>{{rp.rateband}}</td>
                                                <td>{{rp.fromdate | date:'dd-MM-yyyy'}}</td>
                                                <td>{{rp.todate | date:'dd-MM-yyyy'}}</td>
                                                <td>
                                                    <i class="bx bx-trash font-size-16 align-middle me-2"
                                                        (click)="deleteRateBandItem(i)"></i>
                                                </td>
                                            </tr>
                                            <tr *ngIf="rateBandPeriodList?.length === 0">
                                                <td colspan="4" class="text-center">
                                                    No records
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 d-flex flex-grow-1">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> Bank Details </div>
                        <div class="card-body">
                            <app-bank-details formGroupName="bankDetails"></app-bank-details>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex flex-grow-1" formGroupName="lutdetails">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> LUT Details </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutbondno" class="form-label">Bond No.</label>
                                        <input type="text" class="form-control form-control-sm" maxlength="30"
                                            formControlName="txtLutBondNo"
                                            [ngClass]="{ 'is-invalid':(isFormSubmitted ||customerForm.get('lutdetails.txtLutBondNo').touched) && customerForm.get('lutdetails.txtLutBondNo').errors}" />
                                        <div *ngIf="(isFormSubmitted ||customerForm.get('lutdetails.txtLutBondNo').touched) &&customerForm.get('lutdetails.txtLutBondNo').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="customerForm.get('lutdetails.txtLutBondNo').errors.maxlength">Bond No max length is 30 characters.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutissuedate" class="form-label">Issue Date.</label>
                                        <input type="date" class="form-control form-control-sm" maxlength="30"
                                            formControlName="lutIssueDate" />
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="lutilldate" class="form-label">Till Date.</label>
                                        <input type="date" class="form-control form-control-sm" maxlength="30"
                                            formControlName="lutTillDate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm" >Add</button>
                        <a routerLink="/setup/customers"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>